module.exports = __webpack_public_path__ + "media/media/logos/GE-logo-65a97befca8083d9d0e7d98eaf489c6d.png";